import(/* webpackMode: "eager" */ "/opt/synthhotel/app/global-error.tsx");
